module.exports = __webpack_public_path__ + "fonts/IdeaBuddyFont.c1e2c177.eot";